import { computed } from 'vue';
import { UserBankAccountItem } from '@libs/api-reference';
import { UseQueryConfigV2, useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { USER_QUERY_KEYS } from '../constants';

type UseUserBankAccountsQueryOptions = {
  onSuccess?: UseQueryConfigV2<UserBankAccountItem[]>['onSuccess'];
};

export default function useUserBankAccountsQuery({
  onSuccess,
}: UseUserBankAccountsQueryOptions = {}) {
  const {
    result,
    execute: getUserBankAccounts,
    isPending: isLoadingBankAccounts,
    isSuccess: isSuccessBankAccounts,
  } = useQueryV2<UserBankAccountItem[]>(API.getUserBankAccounts, {
    key: USER_QUERY_KEYS.userBankAccounts,
    staleTime: 1000 * 60 * 60, // 1h
    onSuccess,
  });

  const userBankAccounts = computed<UserBankAccountItem[]>(
    () => result.value?.data || []
  );

  return {
    getUserBankAccounts,
    userBankAccounts,
    isLoadingBankAccounts,
    isSuccessBankAccounts,
  };
}
